import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from 'components/CncUI/Typography';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  header: {
    marginTop: 40,
    marginBottom: 0,
    [breakpoints.up('lg')]: {
      fontSize: 48,
      lineHeight: '56px',
    },
  },
  link: {
    color: palette.cncUI.misc.link,
  },
}));

const Dashboard = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} id="AdminDashboard">
      <Grid item xs={12}>
        <Typography variant="h2" id="HeaderTitle" className={classes.header}>
          MyCast&Crew Admin Dashboard
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" size="long" id="HeaderBody">
          Please navigate to the desired tab on the sub menu above.
          <br />
          If you need assistance, please contact product support at{' '}
          <Link
            href="mailto:plus.support@castandcrew.com"
            className={classes.link}
          >
            plus.support@castandcrew.com
          </Link>
          .
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
